import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=716de53b&scoped=true&"
import script from "./Reviews.vue?vue&type=script&lang=ts&"
export * from "./Reviews.vue?vue&type=script&lang=ts&"
import style0 from "./Reviews.vue?vue&type=style&index=0&id=716de53b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716de53b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsReviewsBar: require('/var/www/packages/theme/components/atoms/ReviewsBar.vue').default,AtomsReview: require('/var/www/packages/theme/components/atoms/Review.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,MoleculesKESfPagination: require('/var/www/packages/theme/components/molecules/KESfPagination.vue').default,IconsPencil24px: require('/var/www/packages/theme/components/icons/pencil/Pencil24px.vue').default})
